module.exports = __webpack_public_path__ + "img/fzgg.6460de38.png";